import {
  BrowserRouter,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";

import Home from "./pages/Home";
import AuthPage from "./pages/AuthPage";
import Dashboard from "./pages/Dashboard";
import InstructorDashboard from "./pages/InstructorDashboard";
import Logout from "./pages/Logout";
import Pricing from "./pages/Pricing";
import About from "./pages/About";
import Faq from "./pages/Faq";
import HelpCenter from "./pages/HelpCenter";
import Privacy from "./pages/Privacy";
import TermsAndConditions from "./pages/TermsAndConditions";
import RefundPolicy from "./pages/RefundPolicy";
import BecomeMentor from "./pages/BecomeMentor";
import Checkout from "./pages/Checkout";
import CampusAmbassador from "./pages/CampusAmbassador";

import { AuthProvider, useAuth } from "./context/AuthContext";

import ScrollToTop from "./components/ScrollToTop";
import WhatsAppButton from "./components/WhatsAppButton";

import "./App.css";

function AppRoutes() {
  const { user, loading } = useAuth();

  if (loading) {
    return (
      <div
        style={{
          height: "100vh",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          background: "#020b3d",
          color: "white",
        }}
      >
        Loading...
      </div>
    );
  }

  return (
    <BrowserRouter>
      <ScrollToTop />

      <Routes>
        <Route path="/logout" element={<Logout />} />

        <Route path="/faq" element={<Faq />} />

        <Route path="/help-center" element={<HelpCenter />} />

        <Route path="/privacy" element={<Privacy />} />

        <Route path="/terms" element={<TermsAndConditions />} />

        <Route path="/refund-policy" element={<RefundPolicy />} />

        <Route path="/become-mentor" element={<BecomeMentor />} />

        <Route path="/careers" element={<CampusAmbassador />} />

        <Route
          path="/campus-ambassador"
          element={<CampusAmbassador />}
        />

        <Route path="/" element={<Home />} />

        <Route path="/auth" element={<AuthPage />} />

        <Route
          path="/dashboard"
          element={
            user?.email?.endsWith("@gmail.com") ? (
              <Dashboard />
            ) : (
              <Navigate to="/" replace />
            )
          }
        />

        <Route
          path="/instructor-dashboard"
          element={
            user?.email?.endsWith("@codeion.in") ? (
              <InstructorDashboard />
            ) : (
              <Navigate to="/" replace />
            )
          }
        />

        <Route path="/pricing" element={<Pricing />} />

        <Route path="/checkout" element={<Checkout />} />

        <Route path="/about" element={<About />} />
      </Routes>

      {/* WhatsApp Floating Button */}
      <WhatsAppButton />
    </BrowserRouter>
  );
}

function App() {
  return (
    <AuthProvider>
      <AppRoutes />
    </AuthProvider>
  );
}

export default App;